import(/* webpackMode: "eager", webpackExports: ["MessagesLayer"] */ "/vercel/path0/components/i18n/MessagesLayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JudgeShellFooter"] */ "/vercel/path0/features/judge/components/shell/JudgeShellFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JudgeShellTopbar"] */ "/vercel/path0/features/judge/components/shell/JudgeShellTopbar.tsx");
